frappe.provide("making_tax_digital.MTDUtils");

making_tax_digital.MTDUtils = class {
  static getLocalTimezoneOffset() {
    const now = new Date();
    const offsetMinutes = now.getTimezoneOffset();
    const sign = offsetMinutes > 0 ? "-" : "+";
    const absOffsetMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absOffsetMinutes / 60)).padStart(2, '0');
    const minutes = String(absOffsetMinutes % 60).padStart(2, '0');
    return `UTC${sign}${hours}:${minutes}`;
  }

  static getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  static setCookie(name, value) {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 20);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }

  static generateUUID() {
    return crypto.randomUUID();
  }

  static async getMTDHeaders() {
    const utcOffsetFormat = this.getLocalTimezoneOffset();

    let deviceId = this.getCookie("ERPNext-MTD-Gov-Client-Device-Id");
    if (!deviceId) {
      deviceId = this.generateUUID();
      this.setCookie("ERPNext-MTD-Gov-Client-Device-Id", deviceId);
    }

    const host_public_ip = await making_tax_digital.UrlToIpResolver.resolvePublicIP(window.location.hostname);

    const headers = {
      'Accept': 'application/json',
      // 'Content-Type': 'application/json',
      'X-Frappe-CSRF-Token': frappe.csrf_token,
      'ERPNext-MTD-Gov-Client-Browser-JS-User-Agent': window.navigator.userAgent,
      'ERPNext-MTD-Gov-Client-Screens': `width=${window.screen.width}&height=${window.screen.height}&scaling-factor=${window.devicePixelRatio}&colour-depth=${window.screen.colorDepth}`,
      'ERPNext-MTD-Gov-Client-Timezone': utcOffsetFormat,
      'ERPNext-MTD-Gov-Client-Window-Size': `width=${window.innerWidth}&height=${window.innerHeight}`,
      'ERPNext-MTD-Gov-Vendor-Public-IP': host_public_ip || ""
    };

    return headers;
  }
}